module.exports = __webpack_public_path__ + "img/4f_r_twodays@2x.aac32c06.png";